<ll-topside>
    <evaluacion-interactiva-status></evaluacion-interactiva-status>
</ll-topside>

<evaluacion-interactiva [evaluacionId]="evaluacionId"></evaluacion-interactiva>
